export interface WhatsAppTemplateParamModel {
  id: string;
  index: string;
  field: string;
  componentType: string;
  componentIndex?: number;
}
